// import Topbar from "./components/topbar/Topbar";
// import Sidebar from "./components/sidebar/Sidebar.jsx";
import Home from "./pages/home/Home";
// import ProfilePage from "./pages/profilePage/ProfilePage.jsx";
// import Login from "./pages/Login/Login";
// import RegisterPage from "./pages/registerPage/RegisterPage";
function App() {
  return (
    <>
      <Home />
    </>
  );
}

export default App;
